import React, { Fragment, useEffect, useState, useRef, forwardRef } from 'react';
import Recommendations from './Recommendations';
import { translate } from '../../../../Services/translation';
import DatePicker from "react-datepicker";
import { post } from '../../../../Services/http';


const RecommendationsContainer = (props) => {
    const recommendation1 = useRef(null);
    const recommendation2 = useRef(null);    
    const [validationRecommendation1, setvalidationRecommendation1] = useState([]);
    const [validationRecommendation2, setvalidationRecommendation2] = useState([]);
    const [dateError, setdateError] = useState(false);
    const [dateFormatted, setdateFormatted] = useState('');
    const [date, setdate] = useState('');
    const [error, seterror] = useState(false);      
    const [refresh, setrefresh] = useState(false);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [sameRecommendationForLeftEye, setsameRecommendationForLeftEye] = useState(false);   
    const [anyProductSelected, setanyProductSelected] = useState(false);
    const [sendUpdateMailToCustomer, setsendUpdateMailToCustomer] = useState(true);

    const showAddContainer = () => {
        setAddContainerVisible(true);
    };
  
    let initialAvailableDate = {
        mindate: new Date(),
        maxdate: new Date()
    }    
    const [availableDates, setavailableDates] = useState(initialAvailableDate);

    const youMustSelectText = translate('coptikk.product.youmustselect');
    const rightEyeText = translate('coptikk.product.righteye');
    const leftEyeText = translate('coptikk.product.lefteye');

    const handleResults = () => {
        setanyProductSelected(true);
    }

    useEffect(() => {
        setanyProductSelected(false);
        const currentFullDate = new Date();
        const availableFullDate = new Date(currentFullDate.getFullYear() - 10, currentFullDate.getMonth(), currentFullDate.getDate());
        setavailableDates({mindate: availableFullDate, maxdate: currentFullDate}); 
        
        if (Object.keys(props.recommendationToEdit).length > 0) {
            const fullDateString = props.recommendationToEdit.lastOrderedDate;
            const spliDates = fullDateString.split(".");
            setdate(new Date(spliDates[2], spliDates[1] - 1, spliDates[0]));                      
        }

        if (props.recommendationToEdit && props.recommendationToEdit.recommendationIdentifier) {
            setanyProductSelected(true);
        }
    }, []);

    useEffect(() => {
        if (date) {
            const dateValue = new Date(date);            
            setdateFormatted(`${String(dateValue.getDate()).padStart(2, '0')}-${String(dateValue.getMonth() + 1).padStart(2, '0')}-${dateValue.getFullYear()}`);
        }      
        setdateError(false);
    }, [date]);  
    
    
    const DatePickerInput = forwardRef((data, ref) => {
        const [readOnly, setReadOnly] = useState(false);
        return (
            <div className='completedorderexport__datepicker' onClick={data.onClick} ref={ref} >
                <input className="register__datepicker-input" placeholder={data.placeholder} autoComplete="off" value={dateFormatted} onChange={data.onChange}
                        onFocus={() => setReadOnly((window.innerWidth <= 760))}
                        onBlur={() => setReadOnly(false)}
                        readOnly={readOnly} />
                <div className="register__datepicker-icon" />
            </div>
        );
    });

    const getValuesAndSave = () => {        
        const recommendation1InfoProduct = recommendation1.current.getProductAndVariant();
        const recommendation2InfoProduct = recommendation2.current && recommendation2.current.getProductAndVariant();        

        var recommendation1Info = recommendation1InfoProduct.selectedVariantArticleNumber ? recommendation1.current.getLensSpecificationSelectedValues() : null;
        var recommendation2Info = !sameRecommendationForLeftEye && recommendation2InfoProduct.selectedVariantArticleNumber !== "" ? 
        recommendation2.current.getLensSpecificationSelectedValues() : null;        

        const validateResponse = validateData(recommendation1Info, recommendation2Info, recommendation1InfoProduct, recommendation2InfoProduct);

        if (date && validateResponse.validations1.length <= 0 && validateResponse.validations2.length <= 0) {
            const recommendationRightEyeData = recommendation1InfoProduct.selectedVariantArticleNumber ? 
            getModelDataFormat(recommendation1InfoProduct.selectedVariantArticleNumber, recommendation1Info, true) : null;
            const recommendationLetEyeData = !sameRecommendationForLeftEye && recommendation2InfoProduct.selectedVariantArticleNumber ? 
            getModelDataFormat(recommendation2InfoProduct.selectedVariantArticleNumber, recommendation2Info, false) : null;
            
            post(`/api/customer/${props.customerId}/${sameRecommendationForLeftEye.toString()}/${sendUpdateMailToCustomer.toString()}`, {                
                customerRecommendationItemRight: recommendationRightEyeData,
                customerRecommendationItemLeft: recommendationLetEyeData,
                lastOrderedDate: dateFormatted,
                recommendationIdentifier :  props.recommendationToEdit ? props.recommendationToEdit.recommendationIdentifier : "",
            })        
            .then(() => {
                props.refresh();
            });
        }
    }

    const getModelDataFormat = (articleNumber, recommendationInfo, isRight) => {
        return {articleNumber: articleNumber, 
            strength: isRight ? recommendationInfo.rightEyeStrength : recommendationInfo.leftEyeStrength,
            curve: isRight ? recommendationInfo.rightEyeCurve : recommendationInfo.leftEyeCurve,
            diameter: isRight ? recommendationInfo.rightEyeDiameter : recommendationInfo.leftEyeDiameter,
            cylinder: isRight ? recommendationInfo.rightEyeCylinder : recommendationInfo.leftEyeCylinder,
            axis: isRight ?  recommendationInfo.rightEyeAxis : recommendationInfo.leftEyeAxis,
            packet: isRight ?  recommendationInfo.rightEyePacket : recommendationInfo.leftEyePacket,                        
            add: isRight ? recommendationInfo.rightEyeAddOption : recommendationInfo.leftEyeAddOption,            
            color: isRight ? recommendationInfo.rightcolor : recommendationInfo.leftcolor,
            eyeProductNumber: isRight ? recommendationInfo.rightEyeProductNumber : recommendationInfo.leftEyeProductNumber            
    }
    }

    const validateData = (recommendation1Info, recommendation2Info, recommendation1InfoProduct, recommendation2InfoProduct) => {
        if (!date) {
            setdateError(true);
        }
        setvalidationRecommendation1([]);
        setvalidationRecommendation2([]);     
        let validations1 = [];  
        let validations2 = [];      
        
        if ((recommendation1InfoProduct.selectedProduct === "" || recommendation1InfoProduct.selectedVariantArticleNumber === "")
        && (recommendation2InfoProduct.selectedProduct === "" || recommendation2InfoProduct.selectedVariantArticleNumber === "")) {
            validations1.push(translate('coptikk.adminportal.recommendation.selectproduct'));
        }         

        if (recommendation1InfoProduct.selectedVariantArticleNumber !== "") {                        
            validateLensSpecifications(recommendation1Info, validations1, true);                        
        }

        if (!sameRecommendationForLeftEye && recommendation2InfoProduct.selectedVariantArticleNumber !== "") {                        
            validateLensSpecifications(recommendation2Info, validations2, false);                       
        }

        setvalidationRecommendation1(validations1);
        setvalidationRecommendation2(validations2); 

        return { validations1, validations2 };
    }

    const validateLensSpecifications = (recommendationInfo, validations, isRight) => {
        if ((recommendationInfo.selectedVariantArticleNumber != "" && isRight &&
         (recommendationInfo.rightEyeStrength === "" && recommendationInfo.rightEyeStrength === null)) ||
        (recommendationInfo.selectedVariantArticleNumber != "" && !isRight && 
        (recommendationInfo.leftEyeStrength === "" && recommendationInfo.leftEyeStrength === null))) {
            validations.push(translate('coptikk.product.youmustselectfields'));
        }

        if (recommendationInfo.rightEyeStrength && recommendationInfo.rightEyeStrength !== '0' && recommendationInfo.rightEyeStrength !== null) {
            if (!recommendationInfo.rightEyeCurve || recommendationInfo.rightEyeCurve === '0') {
                validations.push(`${youMustSelectText} ${translate('coptikk.product.curve')} - ${rightEyeText}`);
              }
          
              if (!recommendationInfo.rightEyeDiameter || recommendationInfo.rightEyeDiameter === '0') {
                validations.push(`${youMustSelectText} ${translate('coptikk.product.diameter')} - ${rightEyeText}`);
              }
          
              if (recommendationInfo.hasCylinderOption && (!recommendationInfo.rightEyeCylinder || recommendationInfo.rightEyeCylinder === '0')) {
                validations.push(`${youMustSelectText} ${translate('coptikk.product.cylinder')} - ${rightEyeText}`);
              }
          
              if (recommendationInfo.hasAxisOption && (!recommendationInfo.rightEyeAxis || recommendationInfo.rightEyeAxis === '0')) {
                validations.push(`${youMustSelectText} ${translate('coptikk.product.axis')} - ${rightEyeText}`);
              }
          
              if (recommendationInfo.hasAddOption && (!recommendationInfo.rightEyeAddOption || recommendationInfo.rightEyeAddOption === '0')) {
                validations.push(`${youMustSelectText} ${translate('coptikk.product.addfield')} - ${rightEyeText}`);
              }
          
              if (recommendationInfo.hasColorOption && (!recommendationInfo.rightcolor || recommendationInfo.rightcolor === '0')) {
                validations.push(`${youMustSelectText} ${translate('coptikk.product.color')} - ${rightEyeText}`);
              }
              
              if (!recommendationInfo.rightEyePacket || recommendationInfo.rightEyePacket === '0') {
                validations.push(`${youMustSelectText} ${translate('coptikk.product.packets')} - ${rightEyeText}`);
              }
        }

        if (recommendationInfo.leftEyeStrength && recommendationInfo.leftEyeStrength !== '0' && recommendationInfo.leftEyeStrength !== null) {
            if (!recommendationInfo.leftEyeCurve || recommendationInfo.leftEyeCurve === '0') {
                validations.push(`${youMustSelectText} ${translate('coptikk.product.curve')} - ${leftEyeText}`);
              }
          
              if (!recommendationInfo.leftEyeDiameter || recommendationInfo.leftEyeDiameter === '0') {
                validations.push(`${youMustSelectText} ${translate('coptikk.product.diameter')} - ${leftEyeText}`);
              }
          
              if (recommendationInfo.hasCylinderOption && (!recommendationInfo.leftEyeCylinder || recommendationInfo.leftEyeCylinder === '0')) {
                validations.push(`${youMustSelectText} ${translate('coptikk.product.cylinder')} - ${leftEyeText}`);
              }
          
              if (recommendationInfo.hasAxisOption && (!recommendationInfo.leftEyeAxis || recommendationInfo.leftEyeAxis === '0')) {
                validations.push(`${youMustSelectText} ${translate('coptikk.product.axis')} - ${leftEyeText}`);
              }
          
              if (recommendationInfo.hasAddOption && (!recommendationInfo.leftEyeAddOption || recommendationInfo.leftEyeAddOption === '0')) {
                validations.push(`${youMustSelectText} ${translate('coptikk.product.addfield')} - ${leftEyeText}`);
              }
          
              if (recommendationInfo.hasColorOption && (!recommendationInfo.leftcolor || recommendationInfo.leftcolor === '0')) {
                validations.push(`${youMustSelectText} ${translate('coptikk.product.color')} - ${leftEyeText}`);
              }
              
              if (!recommendationInfo.leftEyePacket || recommendationInfo.leftEyePacket === '0') {
                validations.push(`${youMustSelectText} ${translate('coptikk.product.packets')} - ${leftEyeText}`);
              }
        }

        return validations;
    }

    return(<Fragment>
        <div className='add-recommendation__container'>
            <div className='title-wrapper'>
                <h5 className='title'>{translate('coptikk.adminportal.recommendation.addrecommendation')}</h5>
            </div>
            <div className='add-recommendation__wrapper'>
                {error && <div className='error'>{translate('coptikk.adminportal.recommendation.selectproduct')}</div>}
                <Recommendations onResults={() => handleResults()} ref={recommendation1} validationMessages={validationRecommendation1} key={`${refresh}1`} 
                hideRightEye={false} hideLeftEye={true} recommendationToEdit={props.recommendationToEdit.customerRecommendationItemRight}></Recommendations>            
                <div className='copy column'><input type='checkbox' onClick={() => setsameRecommendationForLeftEye(!sameRecommendationForLeftEye)}></input>{translate('coptikk.adminportal.recommendation.sameinfoforlefteye')}</div>
                {!sameRecommendationForLeftEye &&  
                <Recommendations ref={recommendation2} onResults={() => handleResults()} validationMessages={validationRecommendation2} key={`${refresh}2`} 
                hideRightEye={true} hideLeftEye={false} recommendationToEdit={props.recommendationToEdit.customerRecommendationItemLeft}></Recommendations>}
                {dateError && <div className='error'>{translate('coptikk.adminportal.recommendation.updatedatemandatory')}</div>}
            </div>            
                <div className='date-picker'>
                    <div className='date-picker__wrapper'>
                        <div className="column">
                            <label>{translate('coptikk.adminportal.article.date')}</label>
                            {window.innerWidth <= 760 ?
                                <DatePicker
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText={translate("coptikk.register.selectdate")}
                                    locale="nb"
                                    minDate={availableDates.mindate}
                                    maxDate={availableDates.maxdate}
                                    onChange={(date) => setdate(date)}
                                    popperClassName="booking"
                                    customInput={<DatePickerInput />}
                                /> : <DatePicker
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText={translate("coptikk.register.selectdate")}
                                    locale="nb"
                                    minDate={availableDates.mindate}
                                    maxDate={availableDates.maxdate}
                                    onChange={(date) => setdate(date)}
                                    customInput={<DatePickerInput />}
                                />}
                        </div>
                    </div>
                </div>                      
            <div className='buttons-wrapper'>
                <div className='mailcheckbox-wrapper'>                
                    <input type='checkbox' checked={sendUpdateMailToCustomer} onChange={(e) => setsendUpdateMailToCustomer(e.target.checked)}></input> 
                    <p>{translate("coptikk.adminportal.recommendation.sendupdatemailtext")}</p>                  
                </div> 
                <button className={`save ${anyProductSelected ? 'active' : ''}`} 
                 onClick={() => {setsameRecommendationForLeftEye(false); getValuesAndSave()}}>{translate('coptikk.adminportal.savebuttontext')}</button>
                <a className='discard' onClick={() => {setrefresh(refresh ? false : true);setsameRecommendationForLeftEye(false);setdate('');props.hideAddRceommendation();}}>{translate('coptikk.adminportal.cancel')}</a>
            </div>
        </div>         
    </Fragment>)
}

export default RecommendationsContainer;